import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Grußkartentext", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "ql-bold" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Editor = _resolveComponent("Editor")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_Editor, {
      modelValue: _ctx.greetingCardService.currentGreetingCardText,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.greetingCardService.currentGreetingCardText) = $event)),
      editorStyle: "height: 320px",
      class: "p-mb-4"
    }, {
      toolbar: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_Button, {
      class: "p-mr-2 p-button-secondary",
      type: "submit",
      label: "Zurück",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('2')))
    }),
    _createVNode(_component_Button, {
      class: "p-mr-2",
      disabled: !_ctx.greetingCardService.addressData,
      type: "submit",
      label: "Weiter",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('4')))
    }, null, 8, ["disabled"])
  ], 64))
}